import { useEffect, useState } from "react";
import { DotLoading } from "./LoadingComponent";
import { formatBytes } from "../common_functions/convertBytes";
import { useSelector } from "react-redux";
import { CustomizedTagSelector } from "./TagSelector";
import { get_tags_list,get_mapped_tags_list } from "../assets/constants/global_apis";
import {
  Drawer,
  IconButton,
  Box,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export const SidebarDetailedView = ({mappedTagsChanged,setIsSidebarOpen,isSidebarOpen}) => {
    const [url, setUrl] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    let [tagsList, setTagsList] = useState([])
    let [mappedTags, setMappedTags] = useState([])
    const [fileDetails_, setFileDetails_] = useState(
        {
            "fileName": "",
            "owner": "",
            "size": "",
            "createdDate": "",
            "modifiedDate": ""
        }
    );

    const { fileName, owner, size, createdDate, modifiedDate } = fileDetails_;
    const collections = useSelector(state => state.collections);
    
    const { backendId, path } = {}
    const stream_video = () => {
        setIsLoading(true);        
        collections.backendId && Promise.all([
        fetch(`/api/v1/fetch/stream/${collections.backendId}/${collections.path}`, {
            method: "GET",
        }).then(async (response) => {
            if (!response.ok) {
                const err = await response.json();
                throw err;
            }
            return response;
        })
        .then((data) => {
            setUrl(data.headers.get('location'));
            setError("");
            setIsLoading(false);
            
            
        })
        .catch(error => {
            console.error(error);
            setError(error.detail);
            setIsLoading(false);
        }),
        fetch(`/api/v1/fetch/details/${collections.backendId}/${collections.path}`, {
            method: "GET",
          }).then(response => response.json())
            .then(data => {
              setFileDetails_({
                    fileName: data.fileName,
                    owner: data.owner,
                    size: data.size,
                    createdDate: data.createdDate,
                    modifiedDate: data.modifiedDate
                });            
            })
            .catch(error => console.log(error))
        ]).finally(() => {
            setIsLoading(false);
        });

        
    }
    const fetchTagsDetails = () => {
        get_tags_list().then((data) => {
          setTagsList(data);
        })
      }
      const fetchVideTagDetails = (path) => {
        if (path != '') {
          get_mapped_tags_list(path).then((data) => {
            setMappedTags(data.tags);
          }).catch(() => {
            setMappedTags([]);
      })
    }
  }

    useEffect(() => {
        if(isSidebarOpen){
        fetchTagsDetails();
        fetchVideTagDetails(collections.path)    
        stream_video();
        return () => {
            setUrl('');           
        }
    }
    },[collections,mappedTagsChanged]);

    const downLoadFile = () => {
        fetch(`/api/v1/fetch/download/${collections.backendId}/${collections.path}`, {
            method: "GET",
        }).then(async (response) => {
            if (!response.ok) {
                const err = await response.json();
                throw err;
            }
            return response;
        })
        .then((data) => {
            window.open(data.headers.get('location'), '_blank');
            console.log(data);
        })
        .catch(error => {
            console.error(error);
        })
    }

    return (
        <Drawer
        anchor="right"
        open={isSidebarOpen}
        onClose={() => setIsSidebarOpen(false)}
        PaperProps={{
          sx: {
            minWidth: '60%',
            maxWidth: '60%',
            mt: 4, // top space
            mb: 4, // bottom space
            borderTopLeftRadius: 16,
            borderBottomLeftRadius: 16,
            overflow: 'auto',
            height: 'calc(100% - 64px)', // remove top and bottom space from 100%
          },
        }}
      >
        {/* Drawer Content */}
        <Box sx={{ p: 3, height: '100%', boxSizing: 'border-box' }}>
          {/* Close Button */}
          <Box display="flex" justifyContent="space-between">
          <div className="offcanvas-header">
                <h5 className="offcanvas-title" id="offcanvasRightLabel">Video Details</h5>
                {/* <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button> */}
            </div>
            <IconButton onClick={() => setIsSidebarOpen(false)}>
              <CloseIcon />
            </IconButton>
          </Box>
            
            <div className="offcanvas-body">

                {
                    isLoading ? 
                    <div className="d-flex justify-content-center align-items-center bg-dark rounded-4" style={{height : "240px"}}>
                        <DotLoading />
                    </div> :    
                    <div>
                        <button className="btn btn-dark mb-2" onClick={()=>downLoadFile()}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 me-2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                            </svg>
                            Download file
                        </button>
                       {isSidebarOpen && url && <video controls src={url} className="video-player rounded-3" id="videoPlayer" autoPlay={true} loop={true} width="100%" height="auto" />}
                            {
                                error && 
                                <div className="alert alert-danger mt-2" role="alert">
                                    {error}
                                </div>
                            }
                        
                        <table className="table table-borderless table-striped mt-2" style={{ fontSize: "0.9rem" }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: "180px" }} className="text-muted">File Name</td>
                                    <td>{fileName}</td>
                                </tr>
                                <tr>
                                    <td style={{ width: "180px" }} className="text-muted">File Path</td>
                                    <td>{collections.path}</td>
                                </tr>
                                <tr>
                                    <td className="text-muted">File Size</td>
                                    <td>{formatBytes(size)}</td>
                                </tr>
                                <tr>
                                    <td className="text-muted">Owner</td>
                                    <td>{owner}</td>
                                </tr>
                                <tr>
                                    <td className="text-muted">Created date</td>
                                    <td>{createdDate}</td>
                                </tr>
                                <tr>
                                <td className="text-muted">Tags</td>
                                <td>
                                <CustomizedTagSelector 
                                        elementsData={{ 
                                            elementsList:tagsList,
                                            setElementsList:setTagsList, 
                                            mappedElements: mappedTags, 
                                            setMappedElements: setMappedTags, 
                                            videos: collections.path, 
                                            isViewOnly:true ,
                                            title: 'Tags'
                                        }} 
                                        />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                }               
            </div>
            </Box>
            </Drawer>
    )
}